// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__Dqsq7","heading":"Skills_heading__JbECE","heading-dark":"Skills_heading-dark__XBN7Z","tiles-container":"Skills_tiles-container__ubOK6"};